var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"tree",attrs:{"data":_vm.permissionsList,"default-checked-keys":_vm.checkedNodeIds,"props":_vm.defaultProps,"node-key":"id","show-checkbox":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }